import { render } from "./background.vue?vue&type=template&id=3e2e2262&scoped=true"
import script from "./background.vue?vue&type=script&lang=js"
export * from "./background.vue?vue&type=script&lang=js"

import "./background.vue?vue&type=style&index=0&id=3e2e2262&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2e2262"]])

export default __exports__